import React from "react";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

export default function CitySelect() {
  const classes = useStyles();

  return (
    <Autocomplete
      id="city-select"
      style={{ width: 150 }}
      options={cities}
      defaultValue={cities[0]}
      classes={{
        option: classes.option,
      }}
      autoSelect
      clearText="Очистить"
      closeText="Закрыть"
      openText="Выбор города"
      noOptionsText="Пока что доступен только 1 город"
      autoHighlight
      disableClearable
      getOptionLabel={(option) => option.name }
      renderOption={(option) => (
        <React.Fragment>
          {option.name}, {option.region}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          // label="Город"
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off',
          }}
        />
      )}
    />
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    option: {
      fontSize: 15,
      '& > span': {
        marginRight: 10,
        fontSize: 18,
      },
    },
  })
)

type CityType = {
  id: number;
  name: string;
  region: string;
}

const cities: CityType[] = [
  { id: 1, name: "Волгодонск", region: "Ростовская область" }
]
